import React from 'react';
import { Box, Typography } from '@mui/material';
import { statusBadgeSx, statusBarSx, statusLabelSx } from '../css/revenueItems.styles';
import { getStatusMeta } from '../utils/revenueItems.utils';

const StatusBadge = ({ status }) => {
  const meta = getStatusMeta(status);
  return (
    <Box sx={{ ...statusBadgeSx, bgcolor: meta.bgColor }}>
      <Box sx={{ ...statusBarSx, bgcolor: meta.color }} />
      <Typography sx={{ ...statusLabelSx, color: meta.color }}>{meta.label}</Typography>
    </Box>
  );
};

export default StatusBadge;
